function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css';
import '../style/stars.css';
import { Star } from './star';

/**
 * Appends stars and returns the event when clicking on them
 *
 * @param {Props} props
 * @param {number} [props.averageRating] The rating value after rating has
 * been done.
 * @param {Function} props.clickHandler
 * @param {boolean} [props.inverted=false]
 * @param {number} props.currentlySelectedRating The currently chosen rating by
 *   the user.
 * @param {number} [props.starAmount=5] The amount of stars to show and choose
 * from.
 * @param {SemanticUIColors} [props.starColor=yellow] The color of the icons
 * @param {boolean} [props.votingIsOver=false] Whether the user is allowed
 * to vote
 */
export var Stars =
/*#__PURE__*/
function (_Component) {
  _inherits(Stars, _Component);

  function Stars(props) {
    var _this;

    _classCallCheck(this, Stars);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stars).call(this, props));

    _this.onMouseLeave = function (enteredRating) {
      _this.setState({
        activeStar: -1
      });
    };

    _this.onMouseEnter = function (enteredRating) {
      _this.setState({
        activeStar: enteredRating
      });
    };

    _this.state = {
      activeStar: -1
    };
    return _this;
  }

  _createClass(Stars, [{
    key: "render",
    value: function render() {
      var starArray = [];
      var additionalHalfStar = false;
      var floorStars = 0; // These are the default events. They will fire in any case. The both
      // have "preventDefault" enabled, so in case the onTouchEnd fires,
      // onClick won't be fired.

      var events = {
        onTouchEnd: this.props.clickHandler,
        onClick: this.props.clickHandler // This is used to decided whether we have a touch device (which does
        // not allow hovering) or another devices which allows it. In case it is
        // allowed, attach the onMouseEnter / -Leave event handlers
        //
        // @todo look at possibility to use pointer events instead (aren't
        //       currently supported on Safari, though)

      };

      if (window.matchMedia('(hover: hover)').matches) {
        events = _objectSpread({}, events, {
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave
        });
      } // Check if rating contains half stars or not


      if (this.props.averageRating) {
        floorStars = Math.floor(this.props.averageRating);

        if (this.props.averageRating && this.props.averageRating - floorStars >= 0.25 && this.props.averageRating - floorStars < 0.75) {
          additionalHalfStar = true;
        }

        if (this.props.averageRating && this.props.averageRating - floorStars >= 0.75) {
          floorStars = floorStars + 1;
        }
      } // Check if rating is set from Question component and also check for
      // MouseOver


      for (var i = 1; i <= this.props.starAmount; i++) {
        var starClass = 'invisible';

        if (this.state.activeStar >= i || this.props.currentlySelectedRating >= i) {
          starClass = '';
        }

        if (this.props.votingIsOver) {
          starClass = 'over';

          if (floorStars < i) {
            starClass = 'invisible';

            if (additionalHalfStar && i - 1 === floorStars) {
              starClass = 'over half';
            }
          }
        }

        starArray.push(React.createElement(Star, {
          key: "star-".concat(i),
          i: i,
          inverted: this.props.inverted,
          events: events,
          starColor: this.props.starColor,
          starClass: starClass
        }));
      }

      return React.createElement("div", {
        className: "stars ".concat(this.props.starColor, " ").concat(this.props.inverted ? 'inverted' : '')
      }, starArray, this.props.votingIsOver && this.props.averageRating && React.createElement("div", {
        className: "label average ".concat(this.props.inverted ? 'inverted' : '')
      }, "\u2300", ' ', this.props.averageRating.toLocaleString('fr-CH', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
      })));
    }
  }]);

  return Stars;
}(Component);
Stars.defaultProps = {
  starAmount: 5,
  starColor: 'yellow',
  inverted: false,
  currentlySelectedRating: -1,
  votingIsOver: false
};
export default Stars;